import { render, staticRenderFns } from "./Anulaciones.vue?vue&type=template&id=1582faf7&scoped=true"
import script from "./Anulaciones.vue?vue&type=script&lang=js"
export * from "./Anulaciones.vue?vue&type=script&lang=js"
import style0 from "./Anulaciones.vue?vue&type=style&index=0&id=1582faf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1582faf7",
  null
  
)

export default component.exports